import Ribbon from "@/assets/svg/md-ribbon.svg";
import Attach from "@/assets/svg/md-attach.svg";

import Avatar from "@/assets/img/abnersimoes.jpg";
import Inocavao from "@/assets/img/companies/inovacao.svg";
import Mobint from "@/assets/img/companies/mobint.svg";
import Jota3w from "@/assets/img/companies/jota3w.svg";
import Tuneduc from "@/assets/img/companies/tuneduc.svg";
import Geru from "@/assets/img/companies/geru.svg";
import WeCancer from "@/assets/img/companies/wecancer.svg";
import Hotmart from "@/assets/img/companies/hotmart.svg";
import Algemetric from "@/assets/img/companies/algemetric.svg";

export default {
  namespaced: true,

  state: {
    content: {
      main: {
        intro:
          "Olá! :) Me chamo Abner Simões, sou desenvolvedor de software há dez anos com graduação em design digital. Especializado em front-end, mobile, design system e UX.",
        avatar: Avatar,
        text:
          "Trabalho sempre analisando o usuário e a demanda do produto para me orientar na escolha de tecnologias que melhor os atenda. A seguir, detalharei melhor minha experiência profissional:",
      },
      companies: [
        {
          logo: Algemetric,
          date: "atualmente",
          name: "Algemetric",
          role: "Front-end Engenieer",
          text:
            "Segundo desenvolvedor front-end da empresa, responsável por estruturar a arquitetura do Design System e seus ecossistemas.",
        },
        {
          logo: Hotmart,
          date: "2021 - 2022",
          name: "Hotmart",
          role: "Front-end Engenieer",
          text:
            "Responsável pelo front-end em uma squad de integrações com sistemas de autenticação, webhook e documentações de API.",
        },
        {
          logo: WeCancer,
          date: "2020 - 2021",
          name: "WeCancer",
          role: "Full Stack Developer & UX Designer",
          text:
            "Desenvolvedor em um sistema web e dois apps nativos de monitoramento de paciente. Além disso, responsável pelos processos de UX Design da startup.",
        },
        {
          logo: Geru,
          date: "2018 - 2019",
          name: "Geru",
          role: "Front-end Engineer Senior",
          text:
            "Desenvolvedor Front-end trabalhando em features e design system dos produtos da fintech.",
        },
        {
          logo: Tuneduc,
          date: "2017 - 2018",
          name: "Tuneduc",
          role: "Front-end Engineer Pleno",
          text:
            "Desenvolvedor de aplicações web e mobile no segmento educacional. Trabalhando em produtos de alto nível de acesso e performance.",
        },
        {
          logo: Jota3w,
          date: "2015 - 2016",
          name: "Agência Jota3w",
          role: "Front-end Engineer Pleno",
          text:
            "Líder e supervisor de outros front-end, responsável também por decisões de tecnologia. Trabalhando em projetos para empresas de grande expressão no mercado, como Natura, Nespresso, Odebrecht, entre outras.",
        },
        {
          logo: Mobint,
          date: "2014",
          name: "Agência Mobint",
          role: "Front-end Engineer Pleno",
          text:
            "Desenvolvedor de sites institucionais utilizando WordPress e prestador de manutenção em aplicativos móveis híbridos e nativos.",
        },
        {
          logo: Inocavao,
          date: "2013 - 2014",
          name: "Editora Inovação",
          role: "Front-end Junior & UI Designer",
          text:
            "Responsável pela criação de layouts, desenvolvimento front-end de sites institucionais e e-commerce utilizando a plataform Vtex.",
        },
      ],
      files: [
        {
          icon: Ribbon,
          url:
            "http://81cd1176253f3f59d435-ac22991740ab4ff17e21daf2ed577041.r77.cf1.rackcdn.com/Certificates/ScrumFundamentalsCertified-AbnerSim%C3%B5es-635990.pdf",
          text: "Certificado SFC SCRUMstudy",
        },
        {
          icon: Attach,
          url:
            "https://res.cloudinary.com/abnersimoes/image/upload/v1636119627/abnersimoes/cv.pdf",
          text: "Visualizar Currículo",
        },
      ],
    },
    navFooter: [
      {
        title: "Portfólio",
        url: "/portfolio",
        highlight: false,
      },
    ],
  },
  // O que fazemos
  getters: {},

  mutations: {},

  actions: {},
};
